module.exports = __webpack_public_path__ + "img/xroad7_logo.40a385d2.svg";